
const Heading = ({ text }) => {
    return (
        <h1 className="gap-2.5 w-full text-2xl font-bold max-md:max-w-full text-primary">
            {text}
        </h1>
    );
}

export default Heading;